import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private url: string;

  constructor(private http: HttpClient) {
    // Replace GLOBAL.url with the appropriate URL
    this.url = GLOBAL.url;
  }

  create(token: string, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.http.post<any>(`${this.url}/file/new?page=${page}`, params, { headers });
  }

  getFiles(token: string, page: any = 1): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this.http.post<any>(`${this.url}/file/list?page=${page}`, params, { headers });
  }

 

  deleteFile(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.http.post<any>(`${this.url}/file/remove/${id}?page=${page}`, params, { headers });
  }

  changefolder(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.http.post<any>(`${this.url}/file/changefolder/${id}?page=${page}`, params, { headers });
  }

  getPOfiles(po: string): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token'));
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this.http.post<any>(`${this.url}/file/po/${po}`, params, { headers });
  }

  getContainerPhotos(container_id: string): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token'));
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this.http.post<any>(`${this.url}/file/pifilerequiredbypocontainer/${container_id}`, params, { headers });
  }

  getFilesFolder(token: string, page = 1, perPage = 10, busqueda = "", filtros = [], id: string): Observable<any> {
    //const params = `authorization=${token}`;

    const headers = this.createHeaders();

    let url;
    
    url = `${this.url}/file/folder/${id}?`;

    let json = null;
    if (busqueda === "") {
      json = {
        busqueda: "busqueda",
      };
    }

    json = JSON.stringify(json);

    const params = {
      json: encodeURIComponent(json),
      authorization: token
    };

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.http.post<any>(
      url,
      this.buildSearchParams(params),
      { headers }
    );

    //return this.http.post<any>(`${this.url}/file/folder/${id}?page=${page}`, params, { headers });
  }

  getFilesFolderv1(token: string, page = 1, perPage = 10, busqueda = "", filtros = [], id: string,task:any,
  order:any): Observable<any> {
    //const params = `authorization=${token}`;

    const headers = this.createHeaders();

    let url;
    
    url = `${this.url}/file/folder/${id}?`;

    let json = null;
    if (busqueda === "") {
      json = {
        busqueda: "busqueda",
      };
    }
    json.sort  = [task];
    json.order = order;
    json = JSON.stringify(json);

    const params = {
      json: encodeURIComponent(json),
      authorization: token
    };

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.http.post<any>(
      url,
      this.buildSearchParams(params),
      { headers }
    );

    //return this.http.post<any>(`${this.url}/file/folder/${id}?page=${page}`, params, { headers });
  }

  getFile(token: string, id: string): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.http.post<any>(`${this.url}/file/detail/${id}?page=${page}`, params, { headers });
  }

  update(token: string, task: any, id: string): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.http.post<any>(`${this.url}/file/edit/${id}?page=${page}`, params, { headers });
  }

  searchBetweenFiles(user: string, folder: string, query: string, selectedSearchType: any = '', receiveresultsadvancedsearch: any = '', daterangeadvancedsearch: any = '', searchinitialdate: any = '', searchenddate: any = ''): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.http.get<any>(`https://itaderp.com/search-files/index.php?u=${user}&f=${folder}&q=${query}&selectedSearchType=${selectedSearchType}&receiveresultsadvancedsearch=${receiveresultsadvancedsearch}&daterangeadvancedsearch=${daterangeadvancedsearch}&searchinitialdate=${searchinitialdate}&searchenddate=${searchenddate}`, { headers });
  }

  searchPO(user: string, query: string, apitoken: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.http.get<any>(`https://itaderp.com/search-files/search-po.php?u=${user}&q=${query}&apitoken=${apitoken}`, { headers });
  }

  search(token: string, search: string = null, filter: string = null, order: string = null): Observable<any> {
    const params = `authorization=${token}&filter=${filter}&order=${order}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    let url: string;
    if (search == null) {
      url = `${this.url}/file/search?page=${page}`;
    } else {
      url = `${this.url}/file/search/${search}?page=${page}`;
    }

    return this.http.post<any>(url, params, { headers });
  }

  private createHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  private buildSearchParams(params: any): any {
    return Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&');
  }
 
}
